import { FORM_CREATE_CONFIRMED_ACTION, FORM_CREATE_FAILED_ACTION, FORMS_CONFIRMED_ACTION, FORMS_FAILED_ACTION } from "../actions/actionTypes";


const initialState = {
    list: [],
    data: {},
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export function FormsReducer(state = initialState, action) {
    if (action.type === FORMS_CONFIRMED_ACTION) {
        return {
            ...state,
            list: action.payload,
            errorMessage: '',
            successMessage: 'Forms fetched successfully',
            showLoading: false,
        };
    }else if (action.type === FORM_CREATE_CONFIRMED_ACTION) {
        return {
            ...state,
            data: action.payload,
            errorMessage: '',
            successMessage: 'Form create successfully',
            showLoading: false,
        };
    } else if (
        action.type === FORMS_FAILED_ACTION ||
        action.type === FORM_CREATE_FAILED_ACTION
    ) {
        return {
            ...state,
            errorMessage: action.payload,
            successMessage: '',
            showLoading: false,
        };
    } else {
        return state;
    }

}
